import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { cybervolunteerApi } from "../../api/cybervolunteerApi";
import AuthComponent from "../../components/AuthComponent";
import { useSiteData } from "../../SiteDataContext";

function LoginPage() {
  const original_usernameTitle = "Логин";
  const [usernameTitle, setUsernameTitle] = useState(original_usernameTitle);
  const [isFormError, setIsFormError] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const { siteData, setSiteData } = useSiteData();

  const postLoginPath = useCallback(() => {
    const from = location.state?.from;
    const path = from?.pathname;
    if (path && path !== "/login") {
      return path;
    }
    return "/";
  }, [location.state]);

  const handleFormIsChanged = () => {
    setIsFormError(false);
    setUsernameTitle(original_usernameTitle);
  };

  const loginUser = async ({ username, password }) => {
    const userData = {
      username: username,
      password: password,
    };

    try {
      const response = await cybervolunteerApi.login(userData);

      if (response.data.status === "success" && response.data.token) {
        localStorage.setItem("auth_token", response.data.token);
        localStorage.setItem("auth_username", username);

        setSiteData({ ...siteData, username: username });
        navigate(postLoginPath());
      } else {
        throw new Error(`The response was not ok: ${response} ${response.statusText}`);
      }
    } catch (error) {
      let errorMessage = "Ошибка при регистрации";

      if (error.response) {
        console.error("Error response:", error.response.data);
        if (error.response.data.status === "error") {
          errorMessage = error.response.data.message;
        }
      } else if (error.request) {
        console.error("No response received:", error.request);
      } else {
        console.error("Error:", error.message);
      }

      setUsernameTitle(errorMessage);
      setIsFormError(true);
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("login_via_token");
    const authUsername = params.get("auth_username");

    if (token && authUsername) {
      localStorage.setItem("auth_token", token);
      localStorage.setItem("auth_username", authUsername);

      setSiteData({ ...siteData, username: authUsername });
      navigate(postLoginPath());
    }
  }, [location.search, location.state, setSiteData, siteData, navigate, postLoginPath]);

  return (
    <div className="mh-152 bg-white-blue flex justify-center items-center h-screen">
      <AuthComponent
        usernameTitle={usernameTitle}
        isFormError={isFormError}
        handleFormIsChanged={handleFormIsChanged}
        additionalContent={
          <div className="font-medium text-sm lh-1-2 text-center px-3 mt-8">
            Не помнишь данные для входа?{" "}
            <a href="/new-user" className="underline color-green">
              Заведи новый аккаунт
            </a>
          </div>
        }
        authMessage={location?.state?.message}
        submit={({ username, password }) => {
          loginUser({ username, password });
        }}
      />
    </div>
  );
}

export default LoginPage;
